import { ScopeHooks } from "sockapi/scope-specs";
import { getTeamScopeIdComponents } from "sockapi/scope-specs-util";
import { ScopeType } from "sockapi/scope-types";
import { ScopeTeamIdentifier } from "sockapi/scopes";

export type TeamTimedUnlockScopeSpec = {
  identifier: ScopeTeamIdentifier;
  step: {
    teamId: string;
  };
  stepResponse: never;
};

export const teamTimedUnlockScopeHooks: ScopeHooks<ScopeType.TEAM_TIMED_UNLOCK> =
  {
    identityFunc: (scope) => scope,
    getIdComponents: getTeamScopeIdComponents,
  };
